import moment from 'moment'
import { formatCurrency } from '../../pages/DataEntryPage/utils/currency'
import {
  getFieldId,
  getLegacySubfieldId,
  getLegacySubfieldReviewId,
} from '../../pages/DataEntryPage/utils/utils'
import { DROPDOWN_DEFAULT_VALUE, FIELD_TYPES, FORMATS } from '../../utility/constants'
import { formatUserFullName } from '../../utility/userName'
import { replacePlaceholders } from '../../pages/DataEntryPage/utils/placeholderUtil'
import _ from 'lodash'

export const getFieldsForSettings = (subfields) => {
  let columnsForGroupBy = []
  let columnsForSetting = []
  let selectTotalArr = []

  for (const subfield of subfields) {
    if (subfield.data_structure === FIELD_TYPES.LIST) {
      columnsForGroupBy.push({
        path: subfield.id + '__',
        name: subfield.field_template_name,
        sequence: subfield.sequence,
        children: subfield.childFieldIds,
      })
    }

    if (
      subfield.data_structure === FIELD_TYPES.NUMBER ||
      subfield.data_structure === FIELD_TYPES.CURRENCY
    ) {
      selectTotalArr.push({
        path: subfield.id,
        name: subfield.field_template_name,
        sequence: subfield.sequence,
        children: subfield.childFieldIds,
      })
    }

    columnsForSetting.push({
      path: subfield.id + '__',
      name: subfield.field_template_name,
      sequence: subfield.sequence,
      children: subfield.childFieldIds,
      is_hidden: subfield.is_hidden,
      subfield_width: subfield.subfield_column_width_in_rem,
    })
  }
  return { columnsForGroupBy, columnsForSetting, selectTotalArr }
}

export const normalizeDataForGroupView = (
  rows,
  subfields,
  listData,
  dynamicListData,
  values,
  externalValues = {},
  fieldMappings = {},
  listDataIdMap = {},
  fieldMetadata = {},
) => {
  let normalizedData = []

  rows.forEach((row) => {
    let rowData = {}
    subfields.forEach((sf) => {
      const ftId = getFieldId(sf.id)

      let value = values[getLegacySubfieldId(sf.id, row)]
      let listDataSf = []

      if (sf.data_structure === FIELD_TYPES.LIST || sf.data_structure === FIELD_TYPES.MULTILIST) {
        listDataSf = dynamicListData?.[sf.id] || listData?.[sf.id] || sf.options || []
        if (sf.data_structure === FIELD_TYPES.MULTILIST) {
          if (typeof value === 'string') {
            try {
              const parsed = JSON.parse(value)
              if (Array.isArray(parsed)) value = parsed
              else
                value = value
                  .split(',')
                  .map((v) => v.trim())
                  .filter(Boolean)
            } catch {
              value = value
                .split(',')
                .map((v) => v.trim())
                .filter(Boolean)
            }
          } else if (!Array.isArray(value)) {
            value = value ? [value] : []
          }

          if (value && Array.isArray(value)) {
            value = value.map(val => {
              if (val == null || val === '' || val == DROPDOWN_DEFAULT_VALUE) {
                return ''
              }
              if (typeof val === 'object' && val !== null) {
                return val.value || val.label || val
              }
              if (!sf.list_id) {
                const type = sf?.dynamic_field_type?.type
                const items = dynamicListData?.[type]
                const item = items?.find((ld) => ld.id == val)
                if (type == 'users') {
                  return item ? formatUserFullName(item) : val
                } else {
                  return item ? item?.name : val
                }
              } else {
                const item = Array.isArray(listData) ? listData.find((ld) => ld.id == val) : null
                const listDataValue = item ? item.value : val
                if (typeof listDataValue === 'string' && listDataValue.includes('[[')) {
                  return replacePlaceholders(
                    listDataValue,
                    { ...values, ...externalValues, ...rowData },
                    listDataIdMap,
                    fieldMappings[sf.id] || sf.metadata?.placeholder_map || {},
                    `__${row}`,
                    fieldMetadata
                  )
                }
                return listDataValue ?? ''
              }
            }).filter(Boolean).join(', ')
          }
        } else if (sf.data_structure === FIELD_TYPES.LIST) {
          if (Array.isArray(value)) value = value[0] || ''
          if (value == null || value === '' || value == DROPDOWN_DEFAULT_VALUE) {
            value = ''
          } else if (typeof value === 'object' && value !== null) {
            value = value.value || value.label || ''
          } else {
            if (!sf.list_id) {
              const type = sf?.dynamic_field_type?.type
              const items = dynamicListData?.[type]
              const item = items?.find((ld) => ld.id == value)

              if (type == 'users') {
                value = item ? formatUserFullName(item) : value
              } else {
                value = item ? item?.name : value
              }
            } else {
              const item = Array.isArray(listData) ? listData.find((ld) => ld.id == value) : null
              const listDataValue = item ? item.value : value
              if (typeof listDataValue === 'string' && listDataValue.includes('[[')) {
                value = replacePlaceholders(
                  listDataValue,
                  { ...values, ...externalValues, ...rowData },
                  listDataIdMap,
                  fieldMappings[sf.id] || sf.metadata?.placeholder_map || {},
                  `__${row}`,
                  fieldMetadata
                )
              } else {
                value = listDataValue ?? ''
              }
            }
          }
        } else if (typeof value === 'string' && value.includes('[[')) {
          value = replacePlaceholders(
            value,
            { ...values, ...externalValues, ...rowData },
            listDataIdMap,
            fieldMappings[sf.id] || sf.metadata?.placeholder_map || {},
            `__${row}`,
            fieldMetadata
          )
        }
      }

      rowData[ftId] = {
        ...sf,
        listData: listDataSf,
        value: value,
      }
    })
    normalizedData.push(rowData)
  })
  return normalizedData
}

export const getColumns = (subfields = [], hiddenColumns = [], freezeColumnId = []) => {
  const shouldFreezeColumns = freezeColumnId?.length > 0

  let leftOffset = 50
  const zIndexBase = 100

  const slNoColumn = {
    dataKey: 'slNo',
    label: 'Sl. No.',
    width: 50,
    isFrozen: true,
    leftOffset: 0,
    zIndex: zIndexBase,
  }

  let freezeLimitReached = !shouldFreezeColumns

  const columns = subfields
    ?.filter((it) => {
      const isHidden = hiddenColumns?.includes(it.id) || it.is_hidden
      if (!isHidden) {
        return it
      }
    })
    ?.map((it) => {
      const shouldFreeze = shouldFreezeColumns && !freezeLimitReached

      if (shouldFreeze && it.id == freezeColumnId) {
        // Stop freezing after the freezeColumnId
        freezeLimitReached = true
      }

      const column = {
        dataKey: getFieldId(it.id),
        label: it.field_template_name,
        width: parseInt(it.subfield_column_width_in_rem, 10) * 16,
        numeric: it.data_structure == FIELD_TYPES.NUMBER,
        isFrozen: shouldFreeze,
        leftOffset: shouldFreeze ? leftOffset : null,
        zIndex: shouldFreeze ? zIndexBase + 10 : 1,
      }

      if (shouldFreeze) {
        leftOffset += column.width
      }
      return column
    })

  return [slNoColumn, ...columns]
}

export const getTableRows = (field, values, subfields) => {
  const rawValue = values?.[getFieldId(field.id)]

  if (!field || !Array.isArray(subfields) || subfields.length === 0) {
    return []
  }

  const rowCount = Number(rawValue)

  //  prevent negative or invalid length
  if (!Number.isInteger(rowCount) || rowCount <= 0) {
    return []
  }

  return Array.from({ length: rowCount }, (_, index) => index + 1).filter(
    (row) => values?.[getLegacySubfieldId(subfields[0].id, row)] !== undefined,
  )
}

export const getRowData = (
  rows,
  tableSequenceAndHeaders,
  values,
  reviews,
  subfields,
  hiddenColumns,
  listData,
  dynamicListData,
  previewCurrency,
  freezeColumnId = null,
  externalValues = {},
  fieldMappings = {},
  listDataIdMap = {},
  fieldMetadata = {},
  data = {},
) => {
  let resultData = []
  tableSequenceAndHeaders.forEach(({ row, is_header, header_value }, i) => {
    let rowData = {}
    if (!is_header) {
      rowData = { ...rowData, is_header: false, rowNumber: row }
      subfields
        .filter((it) => !hiddenColumns?.includes(it))
        .forEach((sf) => {
          const _value = values[getLegacySubfieldId(sf.id, row)]
          const _review = reviews[getLegacySubfieldReviewId(sf.id, row)]

          // Handling TIMESTAMPED_BIGTEXT type
          if (sf.data_structure === FIELD_TYPES.TIMESTAMPED_BIGTEXT) {
            let actualValue = null
            if (_value && Array.isArray(_value)) {
              actualValue = _value.map((v, index) => {
                const user = dynamicListData?.users?.find((u) => u.id === v.user_id)
                const username = user ? formatUserFullName(user) : null
                const lines = v.text.split('\n').map((line, i) => (
                  <span key={`${index}-${i}`}>
                    {line}
                    <br />
                  </span>
                ))
                return (
                  <div key={index}>
                    <i>{v.timestamp}:</i> {lines} {username ? ` - ${username}` : ''}
                  </div>
                )
              })
            }
            rowData = {
              ...rowData,
              [getFieldId(sf.id)]: {
                value: actualValue,
                review: _review,
                data_structure: sf.data_structure,
              },
            }
          } else if (sf.data_structure === FIELD_TYPES.LIST) {
            let actualValue = null
            if (_value == null || _value === '' || _value == DROPDOWN_DEFAULT_VALUE) {
              actualValue = ''
            } else if (!sf.list_id) {
              const type = sf?.dynamic_field_type?.type
              const items = dynamicListData[type]
              const item = items?.find((ld) => ld.id == _value)

              if (type == 'users') {
                actualValue = formatUserFullName(item)
              } else {
                actualValue = item?.name
              }
            } else {
              const item = listData.find((ld) => ld.id == _value)
              const listDataValue = item ? item.value : _value
              if (typeof listDataValue === 'string' && listDataValue.includes('[[')) {
                actualValue = replacePlaceholders(
                  listDataValue,
                  { ...data?.data, ...externalValues, ...values },
                  listDataIdMap,
                  fieldMappings[sf.id] || sf.metadata?.placeholder_map || {},
                  `__${row}`,
                  fieldMetadata
                )
              } else {
                actualValue = listDataValue ?? ''
              }
            }

            rowData = {
              ...rowData,
              [getFieldId(sf.id)]: {
                value: actualValue,
                review: _review,
                data_structure: sf.data_structure,
              },
            }
          } else if (sf.data_structure === FIELD_TYPES.LIST_MULTI) {
            let actualValue = []
            if (!sf.list_id) {
              const type = sf?.dynamic_field_type?.type
              const items = dynamicListData[type]
              actualValue = _value
                ?.map((it) => {
                  if (it == null || it === '' || it == DROPDOWN_DEFAULT_VALUE) {
                    return ''
                  }
                  const item = items.find((ld) => ld.id == it)
                  if (type == 'users') {
                    return item ? formatUserFullName(item) : it
                  } else {
                    return item?.name ?? it
                  }
                })
                ?.filter(Boolean)
                ?.join(',')
            } else {
              actualValue = _value
                ?.map((it) => {
                    if (it == null || it === '' || it == DROPDOWN_DEFAULT_VALUE) {
                      return ''
                    }
                    const item = listData.find((ld) => ld.id == it)
                    const listDataValue = item ? item.value : it
                    if (typeof listDataValue === 'string' && listDataValue.includes('[[')) {
                      return replacePlaceholders(
                        listDataValue,
                        { ...data?.data, ...externalValues, ...values },
                        listDataIdMap,
                        fieldMappings[sf.id] || sf.metadata?.placeholder_map || {},
                        `__${row}`,
                        fieldMetadata
                      )
                    }
                    return listDataValue ?? ''
                })
                ?.filter(Boolean)
                ?.join(',')
            }

            rowData = {
              ...rowData,
              [getFieldId(sf.id)]: {
                value: actualValue,
                review: _review,
                data_structure: sf.data_structure,
              },
            }
          } else if (sf.data_structure === FIELD_TYPES.FILE) {
            rowData = {
              ...rowData,
              [getFieldId(sf.id)]: {
                value: _value,
                review: _review,
                data_structure: sf.data_structure,
              },
            }
          } else {
            rowData = {
              ...rowData,
              [getFieldId(sf.id)]: {
                value:
                  sf.data_structure === FIELD_TYPES.CURRENCY
                    ? formatCurrency(_value, previewCurrency[sf.id])
                    : _value,
                review: _review,
                data_structure: sf.data_structure,
              },
            }
          }
        })
    } else {
      rowData = { is_header: true, value: header_value }
    }
    resultData.push(rowData)
  })

  return resultData
}
export const getDateAndDateTime = (value, dataStructure) => {
  if (value === null || value === undefined || !dataStructure) return ''

  if (dataStructure === FIELD_TYPES.DATE) {
    const returnValueDate = moment(value).format(FORMATS.DATE)
    return returnValueDate === 'Invalid date' ? '' : returnValueDate
  } else if (dataStructure === FIELD_TYPES.DATETIME) {
    const returnValueDateTime = moment(value).format(FORMATS.DATETIME)
    return returnValueDateTime === 'Invalid date' ? '' : returnValueDateTime
  }

  return ''
}
